// CommentTopToggle.jsx

import React from 'react';

// CSS
import './CommentTopToggle.css';

/**
 * CommentTopToggle component
 * 
 * Renders a comment replies toggle button for a comment.
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentTopToggle = ({ repliesCount, onClick }) => {

    // ----- RENDER ----- //

    return (

        <div className="comment-top-toggle-container">

            {/* BUTTON */}
            <div
              className="comment-top-toggle-button"
              onClick={onClick}
            >

                <div
                  className="comment-top-toggle-bar"
                ></div>

                View {repliesCount} {repliesCount === 1 ? 'reply' : 'replies'}
            </div>

        </div>

    );
};

// Dev Tools
CommentTopToggle.displayName = 'CommentTopToggle';

export default CommentTopToggle;
